namespace nscs.screen.stories {

    export class AnimationStory_6_2 extends Phaser.GameObjects.Container {

        frame = {name:'AnimationStory_6_2'};

        _bg:Phaser.GameObjects.Image;
        _blackfg:Phaser.GameObjects.Image;
        charsGoingOut_:Phaser.GameObjects.Sprite;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg5' + '0000');
            this._bg.setOrigin(0, 0);

            let shine = this.scene.add.sprite(game.scale.width / 2, 300, 'stories', 'shine' + '0000');
            shine.setOrigin(0.5, 0.5);

            let gopam = this.scene.add.sprite(game.scale.width / 2, 75, 'stories', 'gopam' + '0000');
            gopam.setOrigin(0.5, 0.5);

            this._blackfg = this.scene.add.image(game.scale.width / 2, 385, 'stories', 'blackfg' + '0000');
            this._blackfg.setOrigin(0.5, 1);

            this.charsGoingOut_ = this.scene.add.sprite(game.scale.width / 2, 295, 'stories', 'charsGoingOut_' + '0000');
            this.charsGoingOut_.setOrigin(0.5, 1);

            this.add([this._bg, shine, this._blackfg, gopam, this.charsGoingOut_]);

            this.charsGoingOut_.tint = 0xFFFFFF;
            this.scene.tweens.add({
                targets: this.charsGoingOut_,
                duration: 7000,
                scale: 0.5,
                y: this.charsGoingOut_.y-10,
                tint: 0
            });

            this.scene.tweens.add({
                targets: shine,
                duration: 2500,
                scale: 1.1,
                alpha: 0.7,
                repeat: -1,
                yoyo: true
            });

            let anim:string = nscs.gameplay.Factory.createAnimName('charsGoingOut_', 'walk');
            if (!this.scene.anims.exists(anim)) {
                this.scene.anims.create({
                    key: anim,
                    frames: this.scene.anims.generateFrameNames(this.charsGoingOut_.texture.key, {
                        start: 0, end: 2, zeroPad: 4,
                        prefix: 'charsGoingOut_', suffix: ''
                    }),
                    repeat: -1,
                    frameRate: 8
                });
            }
            this.charsGoingOut_.play(anim);

            let chick_mc_anim:string = 'tinyChickMC-anim';
            if (!this.scene.anims.exists(chick_mc_anim)) {
                this.scene.anims.create({
                    key: chick_mc_anim,
                    frames: this.scene.anims.generateFrameNames('objects-atlas', {
                        start: 0, end: 15, zeroPad: 4,
                        prefix: 'tinyChickMC', suffix: ''
                    }),
                    frameRate: 60,
                    repeat: -1
                });
            }

            for (var i:number = 0; i < 40; i++) {
                let left:boolean = Math.random() > 0.5;
                let s = this.scene.add.sprite(
                    left ? 120 - Math.random() * 75 : 340 - Math.random() * 75,
                    400,
                    'objects-atlas', 'tinyChickMC0000');
                this.add(s);
                s.tint = 0;
                s.setScale(1.25 + Math.random()*0.5);
                this.scene.tweens.add({
                    targets: s,
                    duration: 3500,
                    y: s.y - 350 - Math.random() * 100,
                    x: left ? s.x - 50 : s.x + 50,
                    scale: 0,
                    delay: 300 * i,
                    onStart: ()=>nscs.sound.SoundManager.getInstance().playSound('whistleSND', 0.25)
                });
                s.play(chick_mc_anim);
            }
        }
    }
}
